import {
  getPriceRangeFromQueryParam,
  getSelectedPriceRangeFromRefineParam
} from "./priceRangeUrl";
import {
  getMinMaxFromApiResponse,
  isPriceRangeSelected,
  isFacetPriceRange
} from "./priceRangeSelectors";

export const getCurrentSelectedPriceRange = (
  initialState,
  state,
  hasSelectedValues,
  minMaxBounds,
  refine,
  isNewPage
) => {
  let currentSelectedPriceRange = {};
  if (
    state.range.currentprice.selected.current ===
      initialState.range.currentprice.selected.current ||
    isNewPage
  ) {
    if (hasSelectedValues) {
      const [
        leftIndicator,
        rightIndicator
      ] = getSelectedPriceRangeFromRefineParam(refine);

      currentSelectedPriceRange = {
        leftIndicator,
        rightIndicator
      };
    } else {
      currentSelectedPriceRange = {
        leftIndicator: minMaxBounds.min,
        rightIndicator: minMaxBounds.max
      };
    }
  } else {
    currentSelectedPriceRange = state.range.currentprice.selected.current;
  }

  return currentSelectedPriceRange;
};

const getBound = ({ hasSelected, boundType, queryMinMax, apiMinMax }) => {
  const { [boundType]: query } = queryMinMax;
  const { [boundType]: api } = apiMinMax;

  return hasSelected && Number.isInteger(query) ? query : api;
};

const getBounds = ({
  currentpricerange,
  hasSelectedValues,
  facets,
  refine
}) => {
  const otherFacetsHasSelectedValue = facets.some(
    facet => !isFacetPriceRange(facet) && facet.hasSelectedValues
  );

  const hasSelected = otherFacetsHasSelectedValue || hasSelectedValues;
  let queryMinMax = getPriceRangeFromQueryParam(currentpricerange);

  // Fallback: use refine values as bounds if currentpricerange is missing
  if (Object.keys(queryMinMax).length === 0 && hasSelectedValues) {
    const [min, max] = getSelectedPriceRangeFromRefineParam(refine);
    if (Number.isFinite(min) && Number.isFinite(max)) {
      queryMinMax = { min, max };
    }
  }

  const apiMinMax = getMinMaxFromApiResponse({
    facets
  });

  return ["min", "max"].reduce(
    (bounds, boundType) => ({
      ...bounds,
      [boundType]: getBound({ hasSelected, boundType, queryMinMax, apiMinMax })
    }),
    {}
  );
};

export const getNewRangeState = (
  initialState,
  state,
  facets,
  query,
  isNewPage
) => {
  const { currentpricerange, refine } = query;
  const selectedFromRefine = getSelectedPriceRangeFromRefineParam(refine);
  const hasSelectedValues =
    isPriceRangeSelected({ facets }) ||
    (selectedFromRefine.length === 2 &&
      selectedFromRefine.every(Number.isFinite));

  const minMaxBounds = getBounds({
    currentpricerange,
    hasSelectedValues,
    facets,
    refine
  });

  return {
    currentprice: {
      ...state.range.currentprice,
      selected: {
        ...state.range.currentprice.selected,
        current: getCurrentSelectedPriceRange(
          initialState,
          state,
          hasSelectedValues,
          minMaxBounds,
          refine,
          isNewPage
        )
      },
      ...minMaxBounds,
      hasSelectedValues
    }
  };
};
